/** Matches OTK `NotificationTypes`. */
export const CHAT_MESSAGE_UNREAD = 'chat.message.unread' as const
export const ORDER_STATUS_CHANGED = 'order.status.changed' as const
export const ORDER_DOCUMENT_UPLOADED = 'order.document.uploaded' as const

export type NotificationType = typeof CHAT_MESSAGE_UNREAD | typeof ORDER_STATUS_CHANGED | typeof ORDER_DOCUMENT_UPLOADED | string

/**
 * FE inbox item (unified store for chat + order status + document upload).
 * Legacy socket payload: orderId + isInternal + createdAt.
 * OTK list adds id + type; status adds resolutionId; document adds fileName.
 */
export interface Notification {
  orderId: string
  /** Chat only; false/default for order.status.changed / document.uploaded. */
  isInternal: boolean
  createdAt: string
  /** Present when synced from OTK `/notifications/v1` or module SSE. */
  id?: string
  /** Required when from OTK; socket push defaults to chat.message.unread. */
  type?: NotificationType
  /** Present for order.status.changed. */
  resolutionId?: string
  /** Present for order.document.uploaded. */
  fileName?: string
}

export const isChatNotification = (item: Notification): boolean => !item.type || item.type === CHAT_MESSAGE_UNREAD

export const isOrderStatusNotification = (item: Notification): boolean => item.type === ORDER_STATUS_CHANGED

export const isDocumentUploadedNotification = (item: Notification): boolean => item.type === ORDER_DOCUMENT_UPLOADED

/** Bell dropdown / tab badge: chat + document upload (not status). */
export const isBellNotification = (item: Notification): boolean => isChatNotification(item) || isDocumentUploadedNotification(item)

/** L1 document upload → order card (orders-fe has no `/checks/...`). */
export const documentUploadedHref = (orderId: string): string => `/order/${encodeURIComponent(orderId)}`

export const documentUploadedTitle = (orderId: string): string => `По заявке ${orderId} прикрепили документы`
